// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-right-start-on-rectangle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-right-start-on-rectangle',
  version: 'outline',
  paths: [
    {
      d: 'M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9',
    },
  ],
}
